import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();

  const handleBookingClick = () => {
    navigate('/', { replace: false });
    setTimeout(() => {
      document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/95be4751eb06bc541c78100488dc0357.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 py-32 text-center">
        {/* Important Notice - UPDATED */}
        <div className="mb-8 inline-block bg-white/95 backdrop-blur-sm rounded-2xl px-6 py-4 shadow-lg border-2 border-[#FF9B8A]/30">
          <p className="text-sm md:text-base text-gray-800 leading-relaxed">
            <strong className="text-[#FF9B8A]">本サービスは医療行為・心理療法ではありません。</strong><br />
            心理学専攻の大学生による<strong>傾聴・気持ちの整理を手伝う対話サービス</strong>です
          </p>
        </div>

        <div className="max-w-4xl mx-auto relative z-10">
          <div className="inline-block px-4 py-2 bg-[#FF9B8A]/10 rounded-full mb-6">
            <span className="text-[#FF9B8A] text-sm font-medium">ティーンエイジャー向け</span>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: "'Klee One', cursive" }}>
            こころの相談サポート
          </h1>
          
          <p className="text-xl text-white/90 mb-4 leading-relaxed max-w-2xl mx-auto">
            あなたの気持ちに寄り添い、心の整理をお手伝いします
          </p>
          
          <p className="text-sm text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            一般に「カウンセリング」と呼ばれることがありますが、本サービスは医療・心理療法ではありません
          </p>
        </div>

        <p className="text-xl md:text-2xl text-white/95 mb-4 font-medium">
          ティーンのための、気持ちの整理を手伝う対話サービス
        </p>
        
        <p className="text-base md:text-lg text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
          恋愛、体の変化、親との関係、毎日の小さな不安…<br />
          年齢が近いからこそ、共感できることがある。<br />
          気軽に話せる場所で、一緒に考えよう。
        </p>

        <p className="text-sm text-white/80 mb-12 max-w-3xl mx-auto leading-relaxed bg-black/20 rounded-lg p-4">
          <strong>重要：</strong>本サービスは、心理的な安心感や気持ちの整理を目的とするものであり、症状の改善・回復・行動変容を目的とするものではありません。提供者の発言は、助言・指示・指導ではなく、対話を通じた気づきの補助にとどまります。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button 
            onClick={handleBookingClick}
            className="bg-gradient-to-r from-[#FF9B8A] to-[#FFD93D] hover:from-[#FF8A77] hover:to-[#FFC82D] text-white px-10 py-4 rounded-full text-lg font-bold transition-all shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            今すぐ予約する
          </button>
          
          <a 
            href="#about"
            className="bg-white/90 hover:bg-white text-gray-800 px-10 py-4 rounded-full text-lg font-bold transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
          >
            詳しく見る
          </a>
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-3 gap-8 max-w-3xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="text-3xl md:text-4xl font-bold text-white mb-2">40分</div>
            <div className="text-sm md:text-base text-white/80">1セッション</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="text-3xl md:text-4xl font-bold text-white mb-2">¥3,000</div>
            <div className="text-sm md:text-base text-white/80">気軽な料金</div>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
            <div className="text-3xl md:text-4xl font-bold text-white mb-2">Google Meet</div>
            <div className="text-sm md:text-base text-white/80">オンライン</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl w-8 h-8 flex items-center justify-center"></i>
      </div>
    </section>
  );
}
